<template>
  <div>
    <div>
      <span style="margin-right: 10px; color: #10f7f7">R 实际，喜欢操作使用工具</span><span>喜欢运用技能、操作方法和工具\机器打交道。</span>
    </div>
    <div>
      <span style="margin-right: 10px; color: #10f7f7">
        A 喜欢感性创造</span><span>喜欢想象，并加以具体化地制作或创造某种东西，具有创造力。</span>
    </div>
    <div>
      <span style="margin-right: 10px; color: #10f7f7">E 喜欢控制与影响</span><span>喜欢管理或经营活动，对事件或他人形成影响。</span>
    </div>
    <div>
      <span style="margin-right: 10px; color: #10f7f7">C 传统，喜欢计划与细节</span><span>喜欢有计划和规则，希望遵照既定的安排完成工作任务，关注细节或数据。</span>
    </div>
    <div>
      <span style="margin-right: 10px; color: #10f7f7">S 喜欢与人打交道</span><span>融入社会，喜欢与人沟通、与人接触的活动。</span>
    </div>
    <div>
      <span style="margin-right: 10px; color: #10f7f7">I 喜欢钻研思考</span><span>喜欢运用分析与推理，花工夫进行思考和深度研究。</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  
  
  
};
</script>

<style scoped lang='less'>
</style>
